(function (upp, $) {
    'use strict';

    var $OPT_CART_MODULE_KEY = 'cart',
        $OPT_ORDER_KEY = 'CART.ORDER',
        $OPT_ADDRESS_KEY = 'CART.ADDRESS',
        $OPT_BACK_PATH = '/cart/';

    //Controller for template "/cart/cart-order.html", url "/cart/"
    upp.controller('upp.cart.OrderCtrl', ['$scope', 'appi', 'cartService',
        function ($scope, appi, cartService) {

            var retrieveOrderList = function (successCallback, errorCallback) {
                cartService.retrieveOrderList()
                //No way to use 'success' and 'error' callbacks functions because the promise is explicitly modified with $q.defer, and only has 'then' callback method, where the first parameter is the success callback, and the second one the error
                //Success:
                    .then(function (response) {
                            var data = response.data;
                            if (data.cartIsEmpty) {
                                $scope.order = [];
                            } else {
                                $scope.order = data.order;
                                $scope.currency = data.currency;
                                $scope.totalPrice = data.totalPrice;

                                $scope.prices = {
                                    total: data.totalPriceWithoutTaxes,
                                    taxes: data.totalTaxes,
                                };

                            }

                            successCallback && successCallback();
                        },
                        //Error:
                        function () {
                            errorCallback && errorCallback();
                        });
            };

            appi.ui.changeActualOption({moduleKey2Display: $OPT_CART_MODULE_KEY, navbarKey: $OPT_CART_MODULE_KEY});
            appi.ui.showPageLoadingMsg();

            retrieveOrderList(
                //OK
                function () {
                    $scope.loaded = true;
                    appi.ui.hidePageLoadingMsg();
                },
                //ERR
                function () {
                    $scope.loaded = true;
                    appi.ui.showNetworkError();
                }
            );

            $scope.$on('event:cart:recalculatePrices', function () {
                retrieveOrderList();
            });

        }]);

    //Controller for template "/cart/cart-address.html", url "/cart/address"
    upp.controller('upp.cart.AddressCtrl', ['$scope', 'appi', 'cartService', 'storage', 'translator', 'shippingChargesService', 'pickAtStoreOptionsService', '$q',
        function ($scope, appi, cartService, storage, translator, shippingChargesService, pickAtStoreOptionsService, $q) {

            var _changeActualMenuOption = function () {
                appi.ui.changeActualOption({
                    i18n: $OPT_ORDER_KEY,
                    navbarKey: $OPT_CART_MODULE_KEY
                }, $OPT_BACK_PATH + 'order');
            };

            $scope.updateShippingAddress = function(shippingAddress) {
                $scope.shippingAddress = shippingAddress;
            }
            $scope.updateBillingAddress = function(billingAddress) {
                $scope.billingAddress = billingAddress;
            }
            $scope.copyShippingToBilling = function() {
                $scope.billingAddress = Object.assign({}, $scope.billingAddress, $scope.shippingAddress, {
                    // Always kee the nif from the billing
                    nif: $scope.billingAddress.nif,
                });
            }

            /**
             * Prepare and load all data for the view
             *
             * @private
             */
            var _prepareScopeOrder = function() {
                return cartService.checkStock()
                    .then(function(order) {
                        $scope.currency = cartService.getCurrency();
                        $scope.hasProducts = order.getProducts().length > 0;
                        $scope.shippingAddress = order.getShippingAddress() || {};
                        $scope.billingAddress = order.getBillingAddress() || {};
                        $scope.observations = order.getObservations();
                        $scope.price = order.getPrice();
                        $scope.freeShippingCharges = order.getFreeShippingCharges();
                        $scope.allowsShipping = order.getAllowsShipping();
                        // Payment models
                        $scope.payPalEnabled = order.getPayPal();
                        $scope.redsysEnabled = order.getRedsys();
                        $scope.pickAtStoreEnabled = order.getPickAtStore();
                        $scope.refundEnabled = order.getRefund();
                        $scope.wireTransferEnabled = order.getWireTransfer();
                        $scope.paymentModel = undefined;
                        if ($scope.payPalEnabled) {
                            $scope.paymentModel = cartService.$PAYMENT_PAYPAL;
                        } else if ($scope.refundEnabled) {
                            $scope.paymentModel = cartService.$PAYMENT_REFUND;
                        } else if ($scope.wireTransferEnabled) {
                            $scope.paymentModel = cartService.$PAYMENT_WIRE_TRANSFER;
                        } else if ($scope.redsysEnabled) {
                            $scope.paymentModel = cartService.$PAYMENT_REDSYS;
                        } else if ($scope.pickAtStoreEnabled) {
                            $scope.paymentModel = cartService.$PAYMENT_PICK_AT_STORE;
                        }

                        $scope.minimumOrder = order.getMinimumOrder();
                        $scope.showMinimumOrderWarning = $scope.minimumOrder > 0;

                            // Stock checking
                        $scope.unavailable = order.getUnavailable();
                        if ($scope.unavailable.length > 0)
                            $scope.stockStatusMsg = "CART.STOCK-STATUS.ERR.DESC";
                        else
                            $scope.stockStatusMsg = "CART.STOCK-STATUS.OK.DESC";
                    });
            };

            /**
             * Load the shipping chager for the childupp
             *
             * @private
             */
            var _prepareScopeShippingCharges = function () {
                return shippingChargesService.get()
                    .then(function(response) {
                        var shippingCharges = response.shippingCharges;
                        var fixedShippingCharges = response.fixedShippingCharges;

                        $scope.shippingCharges = shippingCharges;
                        $scope.hasShippingCharges = shippingCharges && shippingCharges.length > 0;
                        if (shippingCharges && shippingCharges.length > 0) {
                            $scope.shippingChargesId = shippingCharges[0].id;
                            if(fixedShippingCharges) {
                                shippingCharges[0].description = translator.i18n('CART.PAYMENT.SHIPPINGCHARGES.FIXED');
                            }
                        }
                    });
            };

            /**
             * Load options for pick at store
             * @returns {Promise<any | never>}
             * @private
             */
            var _prepareScopePickAtStoreOptions = function () {
                return pickAtStoreOptionsService.get()
                    .then(function(response) {
                        var pickAtStoreOptions = response.pickAtStoreOptions;
                        $scope.pickAtStoreOptions = pickAtStoreOptions;
                        if(pickAtStoreOptions && pickAtStoreOptions.lenght > 0){
                            $scope.pickAtStoreOption = pickAtStoreOptions[0];
                        }
                    });
            };

            /**
             * Init function to load and prepare all data for the view
             */
            var init = function() {
                $scope.loaded = false;
                if (cartService.checkOrder()) { // If order has any products....
                    storage.set('redirectToCart', true);
                    appi.ui.showPageLoadingMsg();
                    appi.security.securable({scope: $scope})
                        .then(function () {
                            return $q.all([
                                _prepareScopeOrder(),
                                _prepareScopeShippingCharges(),
                                _prepareScopePickAtStoreOptions()
                            ])
                        })
                        .then(function () {
                            _changeActualMenuOption();
                            $scope.loaded = true;
                            $scope.personType = $scope.personType || 1;
                            storage.remove('redirectToCart');
                            if ($scope.shippingCharges && $scope.shippingCharges.length > 0)
                                $scope.updatePrice($scope.shippingCharges[0].id);
                            appi.ui.hidePageLoadingMsg();
                        })
                        .catch(function (e) {
                            appi.ui.showNetworkError();
                            throw e;
                        })
                } else {
                    _changeActualMenuOption();
                    $scope.loaded = true;
                }
            };

            // Check if the payment model is valid
            $scope.validPaymentModel = function () {
                return cartService.$PAYMENT_MODELS.indexOf($scope.paymentModel) !== -1;
            };

            $scope.validMinimumOrder = function(){
                return $scope.minimumOrder <= 0;
            }

            $scope.updatePrice = function (id) {
                cartService.updateCart(id)
                    .then(function (response) {
                        $scope.price = response.price;
                        $scope.shippingChargesId = id;
                    });
            };

            $scope.updatePickAtStoreOption = function (pickAtStoreOption) {
                $scope.pickAtStoreOption = pickAtStoreOption;
            };

            $scope.next = function () {
                var order = cartService.getOrder();
                order.setShippingAddress($scope.shippingAddress);
                order.setBillingAddress($scope.billingAddress);
                order.setObservations($scope.observations);
                order.setPaymentModel($scope.paymentModel);
                order.setShippingCharges($scope.shippingChargesId);
                order.setPickAtStoreOption($scope.pickAtStoreOption);
                appi.location.path("/cart/payment");
            };

            init();
        }]);

    //Controller for template "/cart/cart-payment.html", url "/cart/payment"
    upp.controller('upp.cart.PaymentCtrl', ['$scope', '$location', 'appi', 'cartService', 'translator', 'wireTransferService', 'storage',
        function ($scope, $location, appi, cartService, translator, wireTransferService, storage) {
            var showError = function () {
                $scope.paymentError = {
                    title: translator.i18n("CART.PAYMENT.ERR.SERVER.PREPARE.TITLE"),
                    msg: translator.i18n("CART.PAYMENT.ERR.SERVER.PREPARE.MSG")
                };
            };

            /**
             * Load the wire transfer data for the childupp
             *
             * @private
             */
            var _prepareScopeWireTransfer = function () {
                return wireTransferService.get()
                    .then(function(response) {
                        $scope.wireTransferBankAccount = response.bankAccount;
                        $scope.wireTransferEmail = response.email;
                    });
            };
            storage.set('redirectToCart', true);
            appi.security.securable({scope: $scope})
                .then(function () {
                    var order = cartService.getOrder();
                    storage.remove('redirectToCart');
                    $scope.order = cartService.getOrder();
                    $scope.currency = cartService.getCurrency();
                    cartService.retrieveTotalPrice()
                        .then(function (response) {
                            $scope.shippingCharges = response.data.shippingCharges;
                            $scope.finalPrice = response.data.totalPriceWithShippingCharges;
                            $scope.finalPriceUSD = response.data.totalPriceWithShippingChargesUSD;
                            $scope.taxes = response.data.totalTaxes;
                            $scope.totalPrice = response.data.totalPriceWithoutTaxes;
                            $scope.shippingFreeCharges = response.data.shippingFreeCharges;
                            $scope.currency = response.data.currency;
                        })
                        .catch(function (err) {
                            // remove the cart because something wrong happens, we want to reset the order
                            // TODO: add some message like 'your order expire, try again'
                            appi.location.path("/cart/order");
                        });

                    appi.ui.changeActualOption({
                        i18n: $OPT_ADDRESS_KEY,
                        navbarKey: $OPT_CART_MODULE_KEY
                    }, $OPT_BACK_PATH + 'address');
                    $scope.correct = true;// cartService.checkAddresses();

                    var successCallback,
                        errorCallback;

                    // Select error and success callbacks depending on the current payment model
                    switch (order.getPaymentModel()) {
                        case cartService.$PAYMENT_REFUND:
                            successCallback = function () {
                                appi.ui.hidePageLoadingMsg();
                                appi.location.path('/cart/payment/success');
                            };

                            errorCallback = function () {
                                appi.ui.hidePageLoadingMsg();
                                appi.location.path('/cart/payment/failure');
                            };

                            $scope.paymentModel = 'REFUND';
                            break;

                        case cartService.$PAYMENT_PAYPAL:
                            successCallback = function (data) {
                                appi.ui.hidePageLoadingMsg();
                                $scope.submitted = true;

                                if (data.paypalURL && data.paypalURL.length) {
                                    appi.location.openWindowInPhonegap(data.paypalURL, data.paypalURL, function (inAppBrowser, event) {
                                        if (event.url.indexOf(data.successURL) > -1) {
                                            appi.location.path("/cart/payment/success", true);
                                            inAppBrowser.close();
                                        }
                                        else if (event.url.indexOf(data.failURL) > -1) {
                                            appi.location.path("/cart/payment/failure", true);
                                            inAppBrowser.close();
                                        }
                                    });
                                } else {
                                    showError();
                                    appi.ui.hidePageLoadingMsg();
                                }
                            };

                            errorCallback = function () {
                                showError();
                                appi.ui.hidePageLoadingMsg()
                            };

                            $scope.paymentModel = 'PAYPAL';
                            break;

                        case cartService.$PAYMENT_REDSYS:
                            successCallback = function (data) {
                                appi.ui.hidePageLoadingMsg();
                                $scope.submitted = true;

                                if (data.redsysURL && data.redsysURL.length) {

                                    storage.set("redsys", JSON.stringify(data));
                                    appi.location.openWindowInPhonegap("/#!/cart/payment/redsys", getRedsysFormContent(data), function (inAppBrowser, event) {
                                        if (event.url.indexOf(data.successURL) > -1) {
                                            appi.location.path("/cart/payment/success", true);
                                            if (!event.closed) {
                                                inAppBrowser.close();
                                            }
                                        }
                                        else if (event.url.indexOf(data.failURL) > -1 || event.closed) {
                                            appi.location.path("/cart/payment/failure", true);
                                            if (!event.closed) {
                                                inAppBrowser.close();
                                            }
                                        }
                                    });
                                } else {
                                    storage.remove("redsys");
                                    showError();
                                    appi.ui.hidePageLoadingMsg();
                                }
                            };

                            errorCallback = function () {
                                showError();
                                appi.ui.hidePageLoadingMsg()
                            };

                            $scope.paymentModel = 'REDSYS';
                            break;

                        case cartService.$PAYMENT_PICK_AT_STORE:
                            successCallback = function () {
                                appi.ui.hidePageLoadingMsg();
                                appi.location.path('/cart/payment/success');
                            };

                            errorCallback = function () {
                                appi.ui.hidePageLoadingMsg();
                                appi.location.path('/cart/payment/failure');
                            };

                            $scope.paymentModel = 'PICKATSTORE';
                            break;

                        case cartService.$PAYMENT_WIRE_TRANSFER:

                            _prepareScopeWireTransfer();

                            successCallback = function () {
                                appi.ui.hidePageLoadingMsg();
                                appi.location.path('/cart/payment/success');
                            };

                            errorCallback = function () {
                                appi.ui.hidePageLoadingMsg();
                                appi.location.path('/cart/payment/failure');
                            };

                            $scope.paymentModel = 'WIRE_TRANSFER';
                            break;
                        default:
                            $location.path('/');
                    }

                    function getRedsysFormContent(data){
                        var pageContent = '<form id="redsys-form" name="form" action="' + data.redsysURL + '" method="POST">'
                            +'<input type="hidden" name="Ds_SignatureVersion" value="' + data.ds_SignatureVersion + '"/>'
                            +'<input type="hidden" name="Ds_MerchantParameters" value="' + data.ds_MerchantParameters + '"/>'
                            +'<input type="hidden" name="Ds_Signature" value="' + data.ds_Signature + '"/>'
                            +'</form>' +
                            '<script type="text/javascript">document.getElementById("redsys-form").submit();</script>';
                        return 'data:text/html;base64,' + btoa(pageContent);
                    }

                    $scope.doPayment = function () {
                        appi.ui.showPageLoadingMsg();

                        cartService.pay()
                            .success(successCallback)
                            .error(errorCallback);
                    };
                });
        }]);

    upp.controller('upp.cart.RedsysCtrl', ['$scope', 'appi', 'cartService', 'storage', '$timeout',
        function ($scope, appi, cartService, storage, $timeout) {
            appi.ui.showPageLoadingMsg();
            var redsys = storage.get("redsys");
            $scope.redsys = JSON.parse(redsys);
            $timeout(() => {
                $("#redsys-form").submit();
                storage.remove("redsys");
                appi.ui.hidePageLoadingMsg();
            }, 500);
        }]);

    //Controller for template "/cart/cart-success.html", url "/cart/payment/success"
    upp.controller('upp.cart.SuccessCtrl', ['$scope', 'cartService', 'appi', '$rootScope',
        function ($scope, cartService, appi, $rootScope) {
            appi.ui.changeActualOption({moduleKey2Display: $OPT_CART_MODULE_KEY, navbarKey: $OPT_CART_MODULE_KEY});
            appi.ui.hidePageLoadingMsg();
            var order = cartService.getOrder();
            cartService.emptyCart();

            $scope.paymentModel = order.getPaymentModel();
            $scope.PAYMENT_PAYPAL = cartService.$PAYMENT_PAYPAL;
            $scope.PAYMENT_REFUND = cartService.$PAYMENT_REFUND;
            $scope.PAYMENT_WIRE_TRANSFER = cartService.$PAYMENT_WIRE_TRANSFER;
            $scope.PAYMENT_REDSYS = cartService.$PAYMENT_REDSYS;
            $scope.PAYMENT_PICK_AT_STORE = cartService.$PAYMENT_PICK_AT_STORE;

            if ($rootScope.setupBackground) $rootScope.setupBackground();
        }]);

    //Controller for template "/cart/cart-failure.html", url "/cart/payment/failure"
    upp.controller('upp.cart.FailureCtrl', ['appi', '$rootScope',
        function (appi, $rootScope) {
            appi.ui.changeActualOption({moduleKey2Display: $OPT_CART_MODULE_KEY, navbarKey: $OPT_CART_MODULE_KEY});
            appi.ui.hidePageLoadingMsg();
            if ($rootScope.setupBackground) $rootScope.setupBackground();
        }]);

})(upp, window.jQuery);



// WEBPACK FOOTER //
// ./src/app/modules/cart/controllers/cart-controllers.js